"use strict";
/*************** LICENSEE ********************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseeIMSchema = exports.LicenseeSchema = exports.BaseLicenseeSchema = exports.LicenseeTypeSchema = void 0;
const zod_1 = require("zod");
const license_schema_1 = require("./license-schema");
const licensee_enums_1 = require("../enums/licensee-enums");
exports.LicenseeTypeSchema = zod_1.z.nativeEnum(licensee_enums_1.LicenseeType);
exports.BaseLicenseeSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: exports.LicenseeTypeSchema,
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    // Common fields
    contactEmail: zod_1.z.string().email(),
    contactPhone: zod_1.z.string().nullish(),
    // Individual fields
    firstName: zod_1.z.string().nullish(),
    lastName: zod_1.z.string().nullish(),
    idNumber: zod_1.z.string().nullish(),
    // Company fields
    legalName: zod_1.z.string().nullish(),
    registrationNumber: zod_1.z.string().nullish(),
    taxNumber: zod_1.z.string().nullish(),
    representativeName: zod_1.z.string().nullish(),
    representativeEmail: zod_1.z.string().nullish(),
});
exports.LicenseeSchema = zod_1.z.lazy(() => exports.BaseLicenseeSchema.extend({
    licenses: zod_1.z.array(zod_1.z.lazy(() => license_schema_1.BaseLicenseSchema)),
}));
exports.LicenseeIMSchema = exports.BaseLicenseeSchema.omit({
    id: true,
    updatedAt: true,
    createdAt: true,
});
